import React, { useEffect, useState } from 'react';
import { CheckCircle, X } from 'lucide-react';
const PURCHASES = [{
  name: 'Valentina',
  city: 'Buenos Aires'
}, {
  name: 'Camila',
  city: 'Santiago'
}, {
  name: 'Sofía',
  city: 'Bogotá'
}, {
  name: 'Isabella',
  city: 'Lima'
}, {
  name: 'Martina',
  city: 'Montevideo'
}, {
  name: 'Lucía',
  city: 'Córdoba'
}, {
  name: 'Fernanda',
  city: 'Ciudad de México'
}, {
  name: 'Gabriela',
  city: 'Medellín'
}, {
  name: 'Ana',
  city: 'Rosario'
}, {
  name: 'Paula',
  city: 'Quito'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showRandomPurchase();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const showRandomPurchase = () => {
    const randomPurchase = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
    setCurrentPurchase(randomPurchase);
    setIsVisible(true);
    // Hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next popup in 10-20 seconds
      const nextDelay = Math.floor(Math.random() * 10000) + 10000;
      setTimeout(showRandomPurchase, nextDelay);
    }, 5000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-slide-up-fade" data-id="element-6">
      <div className="bg-white rounded-lg shadow-xl border-l-4 border-green-500 p-4 flex items-center gap-3 max-w-xs md:max-w-sm" data-id="element-7">
        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-8">
          <CheckCircle className="w-5 h-5 text-green-600" data-id="element-9" />
        </div>
        <div className="flex-1" data-id="element-10">
          <p className="text-xs text-gray-500 font-medium" data-id="element-11">
            Alguien compró hace unos instantes
          </p>
          <p className="text-sm font-bold text-gray-800" data-id="element-12">
            {currentPurchase.name} de {currentPurchase.city}
          </p>
          <p className="text-xs text-purple-600 font-semibold mt-0.5" data-id="element-13">
            Compró "No estás cansada..."
          </p>
        </div>
        <button onClick={() => setIsVisible(false)} className="text-gray-400 hover:text-gray-600 self-start" data-id="element-14">
          <X className="w-4 h-4" data-id="element-15" />
        </button>
      </div>
    </div>;
}